import React, { Component } from 'react';
import { shape, func, string, number, bool, objectOf } from 'prop-types';
import styles from './styles.scss';
import cx from 'classnames';
import { isNumber } from 'lodash';

export default class ChannelsTableRow extends Component {
  static propTypes = {
    data: shape({
      trafficId: string,
      trafficType: string,
      adVisits: number,
      ads: number, 
      visitOfAds: number,
      avgAdCost: number
    }),
    onCellClick: func,
    hideChannelFields: bool,
    isCustomReport: bool,
    summaryData: shape({
      trafficId: string,
      trafficType: string,
      adVisits: number,
      ads: number, 
      visitOfAds: number,
      avgAdCost: number
    }),
    tableColumns: objectOf(shape({
      title: string,
      key: string
    }))
  }

  static defaultProps = {
    data: {},
    summaryData: {}
  }

  render() {
    const { 
      data,
      onCellClick,
      hideChannelFields,
      isCustomReport,
      summaryData,
      tableColumns
    } = this.props;
    const {
      adVisits: totalAdVisits,
      newAdUsers: totalNewAdUsers
    } = summaryData;
    const { trafficType, visitOfAds, adVisits, ads, avgAdCost, newAdUsers, newAdUsersOfAds } = data;
    const adVisitsRate = totalAdVisits && parseFloat((adVisits / totalAdVisits) * 100).toFixed(1) || 0;
    const formattedAdVisit = `${parseFloat(adVisits.toFixed(1)).toLocaleString()} (${adVisitsRate}%)`;
    const newAdUserRate = totalNewAdUsers && parseFloat((newAdUsers / totalNewAdUsers) * 100).toFixed(1) || 0;
    const formattedNewAdUsers = `${parseFloat(newAdUsers.toFixed(1)).toLocaleString()} (${newAdUserRate}%)`;
    const localeAvgAdCost = avgAdCost == null ? `N/A` : `$${avgAdCost.toFixed(2).toLocaleString()}`;
    const tableCellClasses = isCustomReport ? cx(styles.tableCell, styles.customTableCell) : styles.tableCell;
    const formattedVisitOfAds = isNumber(visitOfAds) ? parseFloat(visitOfAds.toFixed(2)).toLocaleString() : 'N/A';
    const formattedNewAdUsersOfAds = isNumber(newAdUsersOfAds) ? parseFloat(newAdUsersOfAds.toFixed(2)).toLocaleString() : 'N/A';
    const formattedData = {
      trafficType,
      adVisits: formattedAdVisit,
      ads: ads.toLocaleString(),
      visitOfAds: formattedVisitOfAds,
      avgAdCost: localeAvgAdCost,
      newAdUsers: formattedNewAdUsers,
      newAdUsersOfAds: formattedNewAdUsersOfAds
    };

    return (
      <div className={styles.tableRow}>
        {
          Object.keys(tableColumns).map(key => (
            <div
              key={key}
              className={hideChannelFields ? styles.tableCellWhenHideChannelFields : tableCellClasses}
              onClick={onCellClick({data, key})}
              data-test={tableColumns[key].rowTestKey}
            >
              {formattedData[key]}
            </div>
          ))
        }
      </div>
    )
  }
}
